import React from "react";
const features = [
  {
    title: "Sales & Customer Lifecycle",
    desc: "Track leads, manage deals and automate your sales pipeline end to end.",
    colorClass: "blue",
    icon: (
      <svg
        width="22"
        height="22"
        fill="none"
        stroke="#185FA5"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
  },
  {
    title: "Scheduling & Operations",
    desc: "Plan installer visits, field audits and team assignments with ease.",
    colorClass: "green",
    icon: (
      <svg
        width="22"
        height="22"
        fill="none"
        stroke="#3B6D11"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    title: "Audits & Compliance",
    desc: "Run field audits, audit checks and maintain regulatory compliance logs.",
    colorClass: "teal",
    icon: (
      <svg
        width="22"
        height="22"
        fill="none"
        stroke="#0F6E56"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <path d="M9 11l3 3L22 4" />
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
      </svg>
    ),
  },
  {
    title: "Inventory Management",
    desc: "Manage products, stock levels, vendors and purchase orders centrally.",
    colorClass: "amber",
    icon: (
      <svg
        width="22"
        height="22"
        fill="none"
        stroke="#854F0B"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
      </svg>
    ),
  },
  {
    title: "Reporting & Insights",
    desc: "Generate detailed reports, export data and track business KPIs live.",
    colorClass: "purple",
    icon: (
      <svg
        width="22"
        height="22"
        fill="none"
        stroke="#534AB7"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </svg>
    ),
  },
  {
    title: "Security & Access",
    desc: "Control roles, permissions and user access with enterprise-grade security.",
    colorClass: "coral",
    icon: (
      <svg
        width="22"
        height="22"
        fill="none"
        stroke="#993C1D"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    ),
  },
];

const sidebarItems = [
  {
    label: "Dashboard",
    active: true,
    icon: (
      <svg
        width="20"
        height="20"
        fill="none"
        stroke="#0f3d3a"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <rect x="14" y="14" width="7" height="7" rx="1" />
      </svg>
    ),
  },
  {
    label: "Prospects",
    active: false,
    icon: (
      <svg
        width="20"
        height="20"
        fill="none"
        stroke="#888"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <circle cx="11" cy="11" r="7" />
        <path d="M21 21l-4.35-4.35" />
      </svg>
    ),
  },
  {
    label: "Team",
    active: false,
    icon: (
      <svg
        width="20"
        height="20"
        fill="none"
        stroke="#888"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    label: "Calendar",
    active: false,
    icon: (
      <svg
        width="20"
        height="20"
        fill="none"
        stroke="#888"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    label: "Reports",
    active: false,
    icon: (
      <svg
        width="20"
        height="20"
        fill="none"
        stroke="#888"
        strokeWidth="1.8"
        viewBox="0 0 24 24"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
      </svg>
    ),
  },
];

export default function Energy(props) {
  return (
    <>
      <div>
        {" "}
        <div id="smooth-wrapper">
          <div id="smooth-content">
            <div class="breadcrumb-section mb-120">
              <div class="container mb-70">
                <div class="row">
                  <div class="col-xl-8 col-lg-10">
                    <div class="breadcrumb-content">
                      <ul class="breadcrumb-list">
                        <li>
                          <a href="service-details.html#">Home</a>
                        </li>
                        <li>
                          <svg
                            width="24"
                            height="6"
                            viewBox="0 0 24 6"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05L-3.26633e-05 2.88672ZM23.7735 2.88672L20.8867 -3.26633e-05L18 2.88672L20.8867 5.77347L23.7735 2.88672ZM2.88672 2.88672V3.38672H20.8867V2.88672V2.38672H2.88672V2.88672Z" />
                          </svg>
                          CRM
                        </li>
                      </ul>
                      <h1>All energy workflows managed in one platform</h1>
                      <div class="para">
                        <div class="icon">
                          <svg
                            width="6"
                            height="49"
                            viewBox="0 0 6 49"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M2.88672 -3.26633e-05L-3.26633e-05 2.88672L2.88672 5.77347L5.77347 2.88672L2.88672 -3.26633e-05ZM2.88672 48.7735L5.77347 45.8867L2.88672 43L-3.26633e-05 45.8867L2.88672 48.7735ZM2.88672 2.88672H2.38672L2.38672 45.8867H2.88672H3.38672L3.38672 2.88672H2.88672Z" />
                          </svg>
                        </div>
                        <p>
                          {" "}
                          Simplify workflows, boost efficiency, and run your
                          entire energy business from one unified platform—built
                          for modern energy companies.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="home5-banner-section">
              <div
                className="banner-content-wrapper"
                style={{ paddingTop: "50px" }}
              >
                <div class="container one">
                  <div class="banner-content text-center">
                    <h1>
                      All energy business workflows managed in one platform
                    </h1>
                    <p>
                      Scale your energy business on a single, integrated
                      platform designed to eliminate silos and accelerate every
                      workflow.
                    </p>

                    <ul>
                      <li>
                        <div class="icon">
                          <img
                            src="assets/image/sass/vector/banner-vector1.svg"
                            alt=""
                          />
                        </div>
                        <div class="content">
                          <h2>All-Inclusive Dashboard</h2>
                        </div>
                      </li>
                      <li>
                        <div class="icon">
                          <img
                            src="assets/image/sass/vector/banner-vector2.svg"
                            alt=""
                          />
                        </div>
                        <div class="content">
                          <h2>Post Audit Forms</h2>
                        </div>
                      </li>
                      <li>
                        <div class="icon">
                          <img
                            src="assets/image/sass/vector/banner-vector3.svg"
                            alt=""
                          />
                        </div>
                        <div class="content">
                          <h2>Installation Scheduling</h2>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="banner-img-area">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12 d-flex justify-content-center mb-120">
                      <div class="banner-img">
                        <img src="assets/crm-banner-2.png" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <section className="ecrm-section">
              <div className="container">
                <div className="ecrm-top text-center">
                  <span className="ecrm-badge">All-Inclusive Platform</span>
                  <h2 className="ecrm-title">
                    Energy suite for your
                    <br />
                    <span>energy-efficient business requirements</span>
                  </h2>
                  <p className="ecrm-subtitle">
                    Our CRM is deliberately built to offer you seamless
                    navigation for all important aspects related to your
                    renewable energy business.
                  </p>
                </div>

                <div className="ecrm-full-grid">
                  {/* ---- ROW 1 ---- */}
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <rect x="3" y="3" width="7" height="7" rx="1" />
                        <rect x="14" y="3" width="7" height="7" rx="1" />
                        <rect x="3" y="14" width="7" height="7" rx="1" />
                        <rect x="14" y="14" width="7" height="7" rx="1" />
                      </svg>
                    </div>
                    <span>Dashboard</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <rect x="2" y="3" width="20" height="14" rx="2" />
                        <path d="M8 21h8M12 17v4" />
                      </svg>
                    </div>
                    <span>CES / VBA</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <circle cx="11" cy="11" r="7" />
                        <path d="M21 21l-4.35-4.35" />
                      </svg>
                    </div>
                    <span>Prospects</span>
                  </div>

                  <div
                    className="ecrm-cell ecrm-cell--feature ecrm-feature--blue"
                    style={{ gridRow: "span 2" }}
                  >
                    <div className="ecrm-feat-icon blue">
                      <svg
                        width="26"
                        height="26"
                        fill="none"
                        stroke="#185FA5"
                        strokeWidth="1.8"
                        viewBox="0 0 24 24"
                      >
                        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                      </svg>
                    </div>
                    <h4>Sales & Customer Lifecycle</h4>
                    <div className="ecrm-tags">
                      <span className="ecrm-tag">Prospects</span>
                      <span className="ecrm-tag">Follow Up</span>
                      <span className="ecrm-tag">CES / VBA</span>
                      <span className="ecrm-tag">Customer</span>
                    </div>
                  </div>
                  <div
                    className="ecrm-cell ecrm-cell--feature ecrm-feature--green"
                    style={{ gridRow: "span 2" }}
                  >
                    <div className="ecrm-feat-icon green">
                      <svg
                        width="26"
                        height="26"
                        fill="none"
                        stroke="#3B6D11"
                        strokeWidth="1.8"
                        viewBox="0 0 24 24"
                      >
                        <rect x="3" y="4" width="18" height="18" rx="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                      </svg>
                    </div>
                    <h4>Scheduling & Operations</h4>
                    <div className="ecrm-tags">
                      <span className="ecrm-tag">Calendar</span>
                      <span className="ecrm-tag">Installer</span>
                      <span className="ecrm-tag">Holidays</span>
                      <span className="ecrm-tag">Trackings</span>
                    </div>
                  </div>
                  <div
                    className="ecrm-cell ecrm-cell--feature ecrm-feature--teal"
                    style={{ gridRow: "span 2" }}
                  >
                    <div className="ecrm-feat-icon teal">
                      <svg
                        width="26"
                        height="26"
                        fill="none"
                        stroke="#0F6E56"
                        strokeWidth="1.8"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 11l3 3L22 4" />
                        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                      </svg>
                    </div>
                    <h4>Audits & Compliance</h4>
                    <div className="ecrm-tags">
                      <span className="ecrm-tag">Field Audit</span>
                      <span className="ecrm-tag">Post Audit</span>
                      <span className="ecrm-tag">Audit Check</span>
                      <span className="ecrm-tag">Assessment</span>
                    </div>
                  </div>

                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                        <circle cx="12" cy="10" r="3" />
                      </svg>
                    </div>
                    <span>Google Map</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <rect x="3" y="4" width="18" height="18" rx="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                      </svg>
                    </div>
                    <span>Calendar</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.58 3.44 2 2 0 0 1 3.55 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.72a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.5 16z" />
                      </svg>
                    </div>
                    <span>Follow Up</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                      </svg>
                    </div>
                    <span>Complaints</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                      </svg>
                    </div>
                    <span>Products</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <rect x="1" y="4" width="22" height="16" rx="2" />
                        <line x1="1" y1="10" x2="23" y2="10" />
                      </svg>
                    </div>
                    <span>Invoice</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34" />
                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                      </svg>
                    </div>
                    <span>E-Sign</span>
                  </div>

                  {/* ---- ROW 2 ---- */}
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                      </svg>
                    </div>
                    <span>Assessment</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M9 11l3 3L22 4" />
                        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
                      </svg>
                    </div>
                    <span>Field Audit</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                      </svg>
                    </div>
                    <span>Audit Check</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                      </svg>
                    </div>
                    <span>Customer</span>
                  </div>

                  <div
                    className="ecrm-cell ecrm-cell--feature ecrm-feature--amber"
                    style={{ gridRow: "span 2" }}
                  >
                    <div className="ecrm-feat-icon amber">
                      <svg
                        width="26"
                        height="26"
                        fill="none"
                        stroke="#854F0B"
                        strokeWidth="1.8"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                      </svg>
                    </div>
                    <h4>Inventory Management</h4>
                    <div className="ecrm-tags">
                      <span className="ecrm-tag">Products</span>
                      <span className="ecrm-tag">Vendors</span>
                      <span className="ecrm-tag">Import</span>
                      <span className="ecrm-tag">Export</span>
                    </div>
                  </div>
                  <div
                    className="ecrm-cell ecrm-cell--feature ecrm-feature--purple"
                    style={{ gridRow: "span 2" }}
                  >
                    <div className="ecrm-feat-icon purple">
                      <svg
                        width="26"
                        height="26"
                        fill="none"
                        stroke="#534AB7"
                        strokeWidth="1.8"
                        viewBox="0 0 24 24"
                      >
                        <line x1="18" y1="20" x2="18" y2="10" />
                        <line x1="12" y1="20" x2="12" y2="4" />
                        <line x1="6" y1="20" x2="6" y2="14" />
                      </svg>
                    </div>
                    <h4>Reporting & Insights</h4>
                    <div className="ecrm-tags">
                      <span className="ecrm-tag">Reports</span>
                      <span className="ecrm-tag">Google Map</span>
                      <span className="ecrm-tag">Logs History</span>
                      <span className="ecrm-tag">Templates</span>
                    </div>
                  </div>
                  <div
                    className="ecrm-cell ecrm-cell--feature ecrm-feature--coral"
                    style={{ gridRow: "span 2" }}
                  >
                    <div className="ecrm-feat-icon coral">
                      <svg
                        width="26"
                        height="26"
                        fill="none"
                        stroke="#993C1D"
                        strokeWidth="1.8"
                        viewBox="0 0 24 24"
                      >
                        <rect x="3" y="11" width="18" height="11" rx="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </div>
                    <h4>Security & Access</h4>
                    <div className="ecrm-tags">
                      <span className="ecrm-tag">Security</span>
                      <span className="ecrm-tag">Roles</span>
                      <span className="ecrm-tag">Permission</span>
                      <span className="ecrm-tag">Departments</span>
                    </div>
                  </div>

                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                    </div>
                    <span>Import</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                      </svg>
                    </div>
                    <span>Team</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <circle cx="12" cy="12" r="3" />
                        <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14" />
                      </svg>
                    </div>
                    <span>Trackings</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <rect x="3" y="11" width="18" height="11" rx="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </div>
                    <span>Security</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                      </svg>
                    </div>
                    <span>Permission</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <circle cx="12" cy="12" r="3" />
                        <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83" />
                      </svg>
                    </div>
                    <span>Logs History</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <circle cx="18" cy="5" r="3" />
                        <circle cx="6" cy="12" r="3" />
                        <circle cx="18" cy="19" r="3" />
                        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
                      </svg>
                    </div>
                    <span>Allocation</span>
                  </div>

                  {/* ---- ROW 3 ---- */}
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                      </svg>
                    </div>
                    <span>Post Audit</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <line x1="18" y1="20" x2="18" y2="10" />
                        <line x1="12" y1="20" x2="12" y2="4" />
                        <line x1="6" y1="20" x2="6" y2="14" />
                      </svg>
                    </div>
                    <span>Reports</span>
                  </div>

                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34" />
                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                      </svg>
                    </div>
                    <span>Contract</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <circle cx="12" cy="12" r="3" />
                        <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 4.93a10 10 0 0 0 0 14.14" />
                      </svg>
                    </div>
                    <span>Installer</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <rect x="3" y="4" width="18" height="18" rx="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                      </svg>
                    </div>
                    <span>Holidays</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14 2 14 8 20 8" />
                      </svg>
                    </div>
                    <span>Templates</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                      </svg>
                    </div>
                    <span>Vendors</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="17 8 12 3 7 8" />
                        <line x1="12" y1="3" x2="12" y2="15" />
                      </svg>
                    </div>
                    <span>Export</span>
                  </div>
                  <div className="ecrm-cell ecrm-cell--icon">
                    <div className="ecrm-mod-icon">
                      <svg
                        width="20"
                        height="20"
                        fill="none"
                        stroke="#888"
                        strokeWidth="1.5"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                      </svg>
                    </div>
                    <span>Roles</span>
                  </div>
                </div>
              </div>
            </section>

            <div class="service-details-page mb-120">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="service-details-content-wrap">
                      <div class="row mb-40">
                        <div class="col-lg-12">
                          <div class="service-details-title">
                            <h2>Manage relationships, gather insights</h2>
                          </div>
                        </div>
                      </div>
                      <div class="row gy-4 mb-80">
                        <div class="col-lg-6">
                          <div class="details-content">
                            <h3> Overview:</h3>
                            <p>
                              Business leaders can analyse needs with ease to
                              identify who requires the most attention and
                              recognise the business processes that deliver
                              superior service to promote repeat business. All
                              data collected can be fully leveraged to assist
                              sales force automation, customer service/support –
                              and marketing.
                            </p>
                          </div>
                        </div>
                        <div class="col-lg-6 d-flex justify-content-lg-center">
                          <div class="details-content">
                            <h3> Our Approach:</h3>
                            <ul class="approach-list">
                              <li>Discover & Research</li>
                              <li>Strategy & Planning</li>
                              <li>Execution & Optimization</li>
                              <li>Measure & Scale</li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-70">
                        <div class="col-lg-12">
                          <div class="service-details-title mb-20">
                            <h2>Key Features:</h2>
                          </div>
                          <div class="key-features-area">
                            <ul class="key-features-list">
                              <li>Automation </li>
                              <li class="two">Analytics</li>
                              <li class="three">Centralization</li>
                              <li class="two">Scalability</li>
                              <li class="four">Integration </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="home1-process-section mb-120">
              <div class="container">
                <div class="row">
                  <div class="col-lg-12 mb-60">
                    <div class="section-title text-center two">
                      <span>Solutions Steps</span>
                      <h2 class="text-anim">How It Works</h2>
                    </div>
                  </div>
                </div>
                <div class="process-wrapper">
                  <div class="row justify-content-center">
                    <div class="col-xl-9 col-lg-11">
                      <div class="row justify-content-between">
                        <div class="col-lg-5 d-lg-block d-none">
                          <div class="process-count">
                            <span>1/4</span>
                          </div>
                        </div>
                        <div class="col-lg-7">
                          <div class="process-list">
                            <div class="single-process">
                              <span class="dot"></span>
                              <div class="process-content-wrap">
                                <div class="icon">
                                  <svg
                                    width="38"
                                    height="38"
                                    viewBox="0 0 38 38"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M34.6633 33.2481L25.8086 24.3934C28.0047 21.8313 29.123 18.5182 28.9288 15.1493C28.7346 11.7804 27.243 8.61768 24.7671 6.3249C22.2912 4.03211 19.0234 2.7875 15.6496 2.85226C12.2757 2.91702 9.0581 4.28613 6.67199 6.67224C4.28588 9.05836 2.91678 12.276 2.85202 15.6498C2.78725 19.0237 4.03186 22.2915 6.32464 24.7674C8.61743 27.2433 11.7801 28.7349 15.149 28.9291C18.5179 29.1233 21.831 28.005 24.3931 25.8089L33.2479 34.6636C33.4361 34.8485 33.6898 34.9515 33.9537 34.9503C34.2176 34.9492 34.4703 34.8438 34.6569 34.6572C34.8435 34.4706 34.9489 34.2178 34.9501 33.954C34.9513 33.6901 34.8482 33.4364 34.6633 33.2481ZM4.92554 15.9371C4.92554 13.7593 5.57135 11.6303 6.78129 9.81953C7.99124 8.00871 9.71099 6.59735 11.7231 5.76392C13.7351 4.93049 15.9492 4.71243 18.0852 5.13731C20.2212 5.56219 22.1832 6.61092 23.7232 8.1509C25.2631 9.69087 26.3119 11.6529 26.7368 13.7889C27.1616 15.9249 26.9436 18.139 26.1101 20.151C25.2767 22.1631 23.8654 23.8829 22.0545 25.0928C20.2437 26.3028 18.1148 26.9486 15.9369 26.9486C13.0175 26.9453 10.2187 25.7841 8.15435 23.7198C6.09002 21.6554 4.92884 18.8565 4.92554 15.9371Z" />
                                  </svg>
                                </div>
                                <div class="process-content">
                                  <h3>Capture & Qualify</h3>
                                  <p>
                                    Capturing leads from different sources and
                                    ensuring they work for your business with a
                                    thorough assessment.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="single-process">
                              <span class="dot"></span>
                              <div class="process-content-wrap two">
                                <div class="icon">
                                  <svg
                                    width="38"
                                    height="38"
                                    viewBox="0 0 38 38"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M35.3281 1.1875H2.67188C2.12091 1.18811 1.59268 1.40725 1.20309 1.79684C0.813499 2.18643 0.594359 2.71466 0.59375 3.26562V27.6094C0.594359 28.1603 0.813499 28.6886 1.20309 29.0782C1.59268 29.4678 2.12091 29.6869 2.67188 29.6875H24.4091L30.8423 36.1208C31.1773 36.4503 31.6289 36.6342 32.0988 36.6323C32.5687 36.6304 33.0188 36.4428 33.3511 36.1106C33.6834 35.7783 33.8709 35.3282 33.8728 34.8583C33.8747 34.3884 33.6909 33.9368 33.3613 33.6018L32.5219 32.7616L29.447 29.6875H35.3281C35.8791 29.6869 36.4073 29.4678 36.7969 29.0782C37.1865 28.6886 37.4056 28.1603 37.4062 27.6094V3.26562C37.4056 2.71466 37.1865 2.18643 36.7969 1.79684C36.4073 1.40725 35.8791 1.18811 35.3281 1.1875ZM19.9263 20.1667C19.8435 20.0836 19.7378 20.027 19.6227 20.0042L17.5238 19.5841C17.4279 19.565 17.3288 19.5698 17.2352 19.5982C17.1417 19.6265 17.0566 19.6776 16.9875 19.7467C16.9184 19.8159 16.8674 19.9011 16.8391 19.9947C16.8109 20.0883 16.8061 20.1874 16.8254 20.2832L17.2447 22.3821C17.2677 22.4972 17.3243 22.6028 17.4073 22.6857L20.8466 26.125H5.34375V4.75H32.6562V26.125H25.8845L19.9263 20.1667ZM20.3463 22.2656L19.5069 23.1058L18.3743 21.9732L18.1643 20.9238L19.2138 21.1338L20.3463 22.2656ZM20.3463 23.9452L21.1857 23.1058L24.1248 26.0448L23.2854 26.8843L20.3463 23.9452ZM32.5219 34.4412C32.6333 34.5526 32.6959 34.7037 32.6959 34.8613C32.6959 35.0188 32.6333 35.17 32.5219 35.2814C32.4105 35.3928 32.2594 35.4554 32.1018 35.4554C31.9443 35.4554 31.7932 35.3928 31.6818 35.2814L31.2624 34.8613L32.1018 34.0219L32.5219 34.4412ZM31.2624 33.1817L30.4223 34.0219L24.1248 27.7237L24.9642 26.8843L31.2624 33.1817ZM36.2188 27.6094C36.2186 27.8455 36.1247 28.0719 35.9577 28.2389C35.7907 28.4059 35.5643 28.4998 35.3281 28.5H28.2595L27.072 27.3125H33.25C33.4075 27.3125 33.5585 27.2499 33.6698 27.1386C33.7812 27.0272 33.8438 26.8762 33.8438 26.7188V4.15625C33.8438 3.99878 33.7812 3.84776 33.6698 3.73641C33.5585 3.62506 33.4075 3.5625 33.25 3.5625H4.75C4.59253 3.5625 4.44151 3.62506 4.33016 3.73641C4.21881 3.84776 4.15625 3.99878 4.15625 4.15625V26.7188C4.15625 26.8762 4.21881 27.0272 4.33016 27.1386C4.44151 27.2499 4.59253 27.3125 4.75 27.3125H22.0341L23.2216 28.5H2.67188C2.43573 28.4998 2.20931 28.4059 2.04233 28.2389C1.87534 28.0719 1.78145 27.8455 1.78125 27.6094V3.26562C1.78145 3.02948 1.87534 2.80306 2.04233 2.63608C2.20931 2.46909 2.43573 2.3752 2.67188 2.375H35.3281C35.5643 2.3752 35.7907 2.46909 35.9577 2.63608C36.1247 2.80306 36.2186 3.02948 36.2188 3.26562V27.6094Z" />
                                    <path d="M2.96875 13.6562C2.81128 13.6562 2.66026 13.7188 2.54891 13.8301C2.43756 13.9415 2.375 14.0925 2.375 14.25V17.8125C2.375 17.9699 2.43756 18.121 2.54891 18.2323C2.66026 18.3437 2.81128 18.4062 2.96875 18.4062C3.12622 18.4062 3.27724 18.3437 3.38859 18.2323C3.49994 18.121 3.5625 17.9699 3.5625 17.8125V14.25C3.5625 14.0925 3.49994 13.9415 3.38859 13.8301C3.27724 13.7188 3.12622 13.6562 2.96875 13.6562ZM35.0312 14.25C34.8738 14.25 34.7228 14.3125 34.6114 14.4239C34.5001 14.5352 34.4375 14.6862 34.4375 14.8437V16.0312C34.4375 16.1887 34.5001 16.3397 34.6114 16.4511C34.7228 16.5624 34.8738 16.625 35.0312 16.625C35.1887 16.625 35.3397 16.5624 35.4511 16.4511C35.5624 16.3397 35.625 16.1887 35.625 16.0312V14.8437C35.625 14.6862 35.5624 14.5352 35.4511 14.4239C35.3397 14.3125 35.1887 14.25 35.0312 14.25ZM25.2397 9.60388C25.1664 9.63041 25.099 9.67113 25.0414 9.72372C24.9838 9.7763 24.9371 9.83971 24.904 9.91034C24.871 9.98096 24.8521 10.0574 24.8486 10.1353C24.8451 10.2132 24.8569 10.2911 24.8835 10.3644C25.2153 11.3043 25.1612 12.3375 24.733 13.2376C24.6107 13.4893 24.4894 13.6505 24.3619 13.7305C24.0965 13.8974 23.6803 13.788 23.4044 13.6436C23.1509 13.4997 22.9098 13.3348 22.6838 13.1506C22.5065 13.0147 22.3232 12.8743 22.1243 12.7442C21.4779 12.3295 20.7445 12.0695 19.9812 11.9846C19.2179 11.8998 18.4454 11.9922 17.7237 12.2549C16.5305 12.7008 15.6901 13.5885 15.4744 14.6295C15.3372 15.293 15.4636 15.9329 15.5753 16.4974L15.8542 17.908C15.8847 18.0625 15.9754 18.1986 16.1062 18.2863C16.2371 18.374 16.3974 18.4061 16.5519 18.3756C16.7064 18.3451 16.8425 18.2544 16.9302 18.1236C17.0179 17.9927 17.05 17.8324 17.0195 17.6779L16.7406 16.2673C16.6464 15.791 16.549 15.2986 16.6375 14.8703C16.7934 14.118 17.5156 13.6012 18.1397 13.3675C18.6866 13.1685 19.2722 13.0985 19.8506 13.1628C20.4291 13.2272 20.9849 13.4242 21.4748 13.7386C21.6365 13.8443 21.7946 13.9654 21.9619 14.0937C22.2412 14.3198 22.5397 14.5211 22.854 14.6953C23.6068 15.0896 24.4068 15.1046 24.994 14.7356C25.4215 14.4669 25.6594 14.0479 25.8011 13.7559C26.0849 13.1681 26.2487 12.5296 26.2828 11.8777C26.317 11.2259 26.2209 10.5737 26.0001 9.95946C25.9464 9.81151 25.8361 9.69094 25.6935 9.62426C25.5509 9.55759 25.3877 9.55025 25.2397 9.60388Z" />
                                  </svg>
                                </div>
                                <div class="process-content">
                                  <h3>Schedule & Assign</h3>
                                  <p>
                                    Leveraging GPS, we schedule team allocation
                                    and assign the tasks accordingly.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="single-process">
                              <span class="dot"></span>
                              <div class="process-content-wrap three">
                                <div class="icon">
                                  <svg
                                    width="38"
                                    height="38"
                                    viewBox="0 0 38 38"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g>
                                      <path d="M21.646 37.3159H16.6195C16.434 37.3159 16.2561 37.2423 16.125 37.1111C15.9938 36.98 15.9201 36.8021 15.9201 36.6166V33.72C14.2038 33.3456 12.5683 32.6674 11.0907 31.7172L9.04119 33.7672C8.97625 33.8322 8.89915 33.8837 8.81429 33.9188C8.72943 33.954 8.63848 33.9721 8.54662 33.9721C8.45477 33.9721 8.36382 33.954 8.27896 33.9188C8.1941 33.8837 8.117 33.8322 8.05205 33.7672L4.4985 30.2137C4.43355 30.1487 4.38202 30.0716 4.34686 29.9867C4.31171 29.9019 4.29361 29.8109 4.29361 29.7191C4.29361 29.6272 4.31171 29.5363 4.34686 29.4514C4.38202 29.3666 4.43355 29.2895 4.4985 29.2245L6.5489 27.1754C5.5988 25.6977 4.92054 24.062 4.54615 22.3456H1.64954C1.46406 22.3456 1.28618 22.2719 1.15503 22.1407C1.02388 22.0096 0.950195 21.8317 0.950195 21.6462V16.6197C0.950195 16.4342 1.02388 16.2563 1.15503 16.1252C1.28618 15.994 1.46406 15.9203 1.64954 15.9203H4.54615C4.92054 14.2039 5.5988 12.5682 6.5489 11.0905L4.49894 9.04095C4.43398 8.97601 4.38245 8.8989 4.3473 8.81405C4.31214 8.72919 4.29405 8.63823 4.29405 8.54638C4.29405 8.45453 4.31214 8.36357 4.3473 8.27871C4.38245 8.19386 4.43398 8.11675 4.49894 8.05181L8.05249 4.49826C8.11743 4.4333 8.19454 4.38177 8.2794 4.34662C8.36426 4.31146 8.45521 4.29337 8.54706 4.29337C8.63891 4.29337 8.72987 4.31146 8.81473 4.34662C8.89958 4.38177 8.97669 4.4333 9.04163 4.49826L11.0907 6.54865C12.5684 5.59848 14.2041 4.92022 15.9206 4.5459V1.6493C15.9206 1.46382 15.9943 1.28594 16.1254 1.15479C16.2566 1.02363 16.4344 0.949951 16.6199 0.949951H21.6465C21.8319 0.949951 22.0098 1.02363 22.141 1.15479C22.2721 1.28594 22.3458 1.46382 22.3458 1.6493V4.5459C24.0623 4.92022 25.698 5.59848 27.1757 6.54865L29.2252 4.4987C29.2901 4.43374 29.3672 4.38221 29.4521 4.34705C29.537 4.3119 29.6279 4.29381 29.7198 4.29381C29.8116 4.29381 29.9026 4.3119 29.9874 4.34705C30.0723 4.38221 30.1494 4.43374 30.2143 4.4987L33.7679 8.05225C33.8328 8.11719 33.8844 8.19429 33.9195 8.27915C33.9547 8.36401 33.9728 8.45496 33.9728 8.54682C33.9728 8.63867 33.9547 8.72962 33.9195 8.81448C33.8844 8.89934 33.8328 8.97644 33.7679 9.04139L31.7175 11.0905C32.6676 12.5682 33.3458 14.2039 33.7202 15.9203H36.6168C36.8023 15.9203 36.9802 15.994 37.1114 16.1252C37.2425 16.2563 37.3162 16.4342 37.3162 16.6197V21.6462C37.3162 21.8317 37.2425 22.0096 37.1114 22.1407C36.9802 22.2719 36.8023 22.3456 36.6168 22.3456H33.7202C33.3458 24.062 32.6676 25.6977 31.7175 27.1754L33.7674 29.225C33.8324 29.2899 33.8839 29.367 33.9191 29.4519C33.9542 29.5367 33.9723 29.6277 33.9723 29.7195C33.9723 29.8114 33.9542 29.9023 33.9191 29.9872C33.8839 30.072 33.8324 30.1491 33.7674 30.2141L30.2139 33.7676C30.149 33.8326 30.0719 33.8841 29.987 33.9193C29.9021 33.9544 29.8112 33.9725 29.7193 33.9725C29.6275 33.9725 29.5365 33.9544 29.4517 33.9193C29.3668 33.8841 29.2897 33.8326 29.2248 33.7676L27.1757 31.7172C25.698 32.6674 24.0623 33.3457 22.3458 33.72V36.6166C22.3458 36.7085 22.3277 36.7995 22.2925 36.8843C22.2574 36.9692 22.2058 37.0463 22.1408 37.1113C22.0758 37.1762 21.9987 37.2277 21.9138 37.2628C21.8289 37.298 21.7379 37.316 21.646 37.3159ZM17.3188 35.9173H20.9467V33.1457C20.9467 32.9815 21.0045 32.8226 21.1099 32.6967C21.2153 32.5708 21.3616 32.4861 21.5232 32.4572C23.4435 32.1174 25.2662 31.3616 26.8636 30.2429C26.9983 30.1491 27.1617 30.1057 27.3252 30.1203C27.4887 30.1348 27.6419 30.2064 27.7579 30.3225L29.7191 32.2833L32.2835 29.7189L30.3227 27.7581C30.2065 27.642 30.1349 27.4888 30.1203 27.3252C30.1058 27.1616 30.1493 26.9981 30.2432 26.8633C31.3619 25.266 32.1176 23.4433 32.4575 21.523C32.4863 21.3614 32.5711 21.215 32.6969 21.1096C32.8228 21.0042 32.9817 20.9465 33.1459 20.9464H35.9175V17.3186H33.1459C32.9817 17.3186 32.8228 17.2608 32.6969 17.1554C32.5711 17.05 32.4863 16.9037 32.4575 16.7421C32.1176 14.8218 31.3619 12.9991 30.2432 11.4017C30.1495 11.267 30.1061 11.1037 30.1207 10.9403C30.1352 10.7769 30.2067 10.6238 30.3227 10.5078L32.2835 8.54704L29.7191 5.98262L27.7579 7.94341C27.6419 8.05951 27.4887 8.1311 27.3252 8.14564C27.1617 8.16019 26.9983 8.11676 26.8636 8.02296C25.2662 6.90429 23.4435 6.14853 21.5232 5.80866C21.3616 5.77983 21.2153 5.69506 21.1099 5.5692C21.0045 5.44334 20.9467 5.28441 20.9467 5.12024V2.34864H17.3188V5.12024C17.3188 5.28441 17.261 5.44334 17.1556 5.5692C17.0502 5.69506 16.9039 5.77983 16.7423 5.80866C14.822 6.14853 12.9993 6.90429 11.4019 8.02296C11.2673 8.11653 11.1041 8.15982 10.9408 8.14528C10.7775 8.13074 10.6245 8.05929 10.5085 7.94341L8.54728 5.98262L5.98286 8.54704L7.94366 10.5078C8.05987 10.6239 8.13152 10.7771 8.14607 10.9407C8.16061 11.1043 8.11712 11.2678 8.02321 11.4026C6.90453 12.9999 6.14877 14.8226 5.8089 16.7429C5.78007 16.9046 5.6953 17.0509 5.56944 17.1563C5.44358 17.2617 5.28465 17.3194 5.12048 17.3195H2.34889V20.9473H5.12048C5.28465 20.9473 5.44358 21.0051 5.56944 21.1105C5.6953 21.2159 5.78007 21.3622 5.8089 21.5238C6.14877 23.4441 6.90453 25.2668 8.02321 26.8642C8.11689 26.9989 8.16025 27.1622 8.1457 27.3256C8.13116 27.489 8.05964 27.6421 7.94366 27.7581L5.98286 29.7189L8.54728 32.2833L10.5085 30.3225C10.6245 30.2064 10.7777 30.1348 10.9412 30.1203C11.1047 30.1057 11.2681 30.1491 11.4028 30.2429C13.0002 31.3616 14.8229 32.1174 16.7432 32.4572C16.9048 32.4861 17.0511 32.5708 17.1565 32.6967C17.2619 32.8226 17.3197 32.9815 17.3197 33.1457L17.3188 35.9173Z" />
                                      <path d="M19.1344 10.2912C18.9489 10.2912 18.771 10.2175 18.6399 10.0863C18.5087 9.95518 18.4351 9.7773 18.4351 9.59182V7.05189C18.4351 6.86641 18.5087 6.68853 18.6399 6.55737C18.771 6.42622 18.9489 6.35254 19.1344 6.35254C19.3199 6.35254 19.4978 6.42622 19.6289 6.55737C19.7601 6.68853 19.8338 6.86641 19.8338 7.05189V9.59182C19.8338 9.7773 19.7601 9.95518 19.6289 10.0863C19.4978 10.2175 19.3199 10.2912 19.1344 10.2912Z" />
                                      <path d="M19.1344 31.9131C18.9489 31.9131 18.771 31.8394 18.6399 31.7083C18.5087 31.5771 18.4351 31.3992 18.4351 31.2138V28.4601C18.4351 28.2746 18.5087 28.0967 18.6399 27.9656C18.771 27.8344 18.9489 27.7607 19.1344 27.7607C19.3199 27.7607 19.4978 27.8344 19.6289 27.9656C19.7601 28.0967 19.8338 28.2746 19.8338 28.4601V31.2138C19.8338 31.3992 19.7601 31.5771 19.6289 31.7083C19.4978 31.8394 19.3199 31.9131 19.1344 31.9131Z" />
                                      <path d="M19.1344 17.0477C18.9489 17.0477 18.771 16.974 18.6399 16.8428C18.5087 16.7117 18.4351 16.5338 18.4351 16.3483V13.9264C18.4351 13.7409 18.5087 13.563 18.6399 13.4319C18.771 13.3007 18.9489 13.2271 19.1344 13.2271C19.3199 13.2271 19.4978 13.3007 19.6289 13.4319C19.7601 13.563 19.8338 13.7409 19.8338 13.9264V16.3483C19.8338 16.5338 19.7601 16.7117 19.6289 16.8428C19.4978 16.974 19.3199 17.0477 19.1344 17.0477Z" />
                                      <path d="M19.1344 24.8204C18.9489 24.8204 18.771 24.7467 18.6399 24.6155C18.5087 24.4844 18.4351 24.3065 18.4351 24.121V21.9159C18.4351 21.7304 18.5087 21.5525 18.6399 21.4214C18.771 21.2902 18.9489 21.2166 19.1344 21.2166C19.3199 21.2166 19.4978 21.2902 19.6289 21.4214C19.7601 21.5525 19.8338 21.7304 19.8338 21.9159V24.121C19.8338 24.3065 19.7601 24.4844 19.6289 24.6155C19.4978 24.7467 19.3199 24.8204 19.1344 24.8204Z" />
                                      <path d="M20.1951 14.8737C19.7201 14.8749 19.2513 14.7663 18.8253 14.5564C18.6604 14.4737 18.5348 14.3292 18.476 14.1543C18.4171 13.9795 18.4298 13.7885 18.5111 13.6229C18.5925 13.4573 18.7359 13.3306 18.9103 13.2703C19.0846 13.21 19.2758 13.2211 19.442 13.3011C19.6762 13.4166 19.9339 13.4765 20.1951 13.4759C20.6496 13.4759 21.0856 13.2953 21.407 12.9739C21.7284 12.6525 21.9089 12.2166 21.9089 11.7621C21.9089 11.3075 21.7284 10.8716 21.407 10.5502C21.0856 10.2288 20.6496 10.0482 20.1951 10.0482C19.9339 10.0476 19.6762 10.1075 19.442 10.2231C19.2758 10.303 19.0846 10.3141 18.9103 10.2538C18.7359 10.1935 18.5925 10.0668 18.5111 9.90123C18.4298 9.73566 18.4171 9.54464 18.476 9.3698C18.5348 9.19495 18.6604 9.05044 18.8253 8.96773C19.2513 8.75763 19.7201 8.64902 20.1951 8.6504C21.0206 8.6504 21.8123 8.97833 22.396 9.56204C22.9797 10.1458 23.3076 10.9374 23.3076 11.7629C23.3076 12.5884 22.9797 13.3801 22.396 13.9638C21.8123 14.5475 21.0206 14.8755 20.1951 14.8755V14.8737Z" />
                                      <path d="M20.1951 29.4025C19.7201 29.4039 19.2513 29.2952 18.8253 29.0851C18.6681 28.9982 18.5503 28.8541 18.4965 28.6826C18.4427 28.5112 18.457 28.3257 18.5363 28.1645C18.6156 28.0033 18.7539 27.8788 18.9225 27.8168C19.0912 27.7548 19.2772 27.7601 19.442 27.8316C19.6762 27.9472 19.9339 28.007 20.1951 28.0064C20.6496 28.0064 21.0856 27.8258 21.407 27.5044C21.7284 27.183 21.9089 26.7471 21.9089 26.2926C21.9089 25.838 21.7284 25.4021 21.407 25.0807C21.0856 24.7593 20.6496 24.5787 20.1951 24.5787C19.9339 24.5781 19.6762 24.638 19.442 24.7536C19.2758 24.8336 19.0846 24.8446 18.9103 24.7843C18.7359 24.7241 18.5925 24.5973 18.5111 24.4317C18.4298 24.2662 18.4171 24.0752 18.476 23.9003C18.5348 23.7255 18.6604 23.581 18.8253 23.4982C19.2513 23.2884 19.7201 23.1798 20.1951 23.1809C21.0206 23.1809 21.8123 23.5088 22.396 24.0926C22.9797 24.6763 23.3076 25.468 23.3076 26.2934C23.3076 27.1189 22.9797 27.9106 22.396 28.4943C21.8123 29.078 21.0206 29.406 20.1951 29.406V29.4025Z" />
                                      <path d="M24.2296 19.7254H21.913C21.7275 19.7254 21.5496 19.6517 21.4185 19.5205C21.2873 19.3894 21.2136 19.2115 21.2136 19.026C21.2136 18.8405 21.2873 18.6626 21.4185 18.5315C21.5496 18.4003 21.7275 18.3267 21.913 18.3267H24.2296C24.415 18.3267 24.5929 18.4003 24.7241 18.5315C24.8552 18.6626 24.9289 18.8405 24.9289 19.026C24.9289 19.2115 24.8552 19.3894 24.7241 19.5205C24.5929 19.6517 24.415 19.7254 24.2296 19.7254Z" />
                                      <path d="M16.3531 19.7254H14.0365C13.851 19.7254 13.6731 19.6517 13.542 19.5205C13.4108 19.3894 13.3372 19.2115 13.3372 19.026C13.3372 18.8405 13.4108 18.6626 13.542 18.5315C13.6731 18.4003 13.851 18.3267 14.0365 18.3267H16.3531C16.5386 18.3267 16.7164 18.4003 16.8476 18.5315C16.9788 18.6626 17.0524 18.8405 17.0524 19.026C17.0524 19.2115 16.9788 19.3894 16.8476 19.5205C16.7164 19.6517 16.5386 19.7254 16.3531 19.7254Z" />
                                      <path d="M31.2139 19.7254H28.5656C28.3801 19.7254 28.2022 19.6517 28.071 19.5205C27.9399 19.3894 27.8662 19.2115 27.8662 19.026C27.8662 18.8405 27.9399 18.6626 28.071 18.5315C28.2022 18.4003 28.3801 18.3267 28.5656 18.3267H31.2139C31.3994 18.3267 31.5773 18.4003 31.7084 18.5315C31.8396 18.6626 31.9132 18.8405 31.9132 19.026C31.9132 19.2115 31.8396 19.3894 31.7084 19.5205C31.5773 19.6517 31.3994 19.7254 31.2139 19.7254Z" />
                                      <path d="M9.70052 19.7254H7.05262C6.86714 19.7254 6.68926 19.6517 6.5581 19.5205C6.42695 19.3894 6.35327 19.2115 6.35327 19.026C6.35327 18.8405 6.42695 18.6626 6.5581 18.5315C6.68926 18.4003 6.86714 18.3267 7.05262 18.3267H9.70008C9.88556 18.3267 10.0634 18.4003 10.1946 18.5315C10.3257 18.6626 10.3994 18.8405 10.3994 19.026C10.3994 19.2115 10.3257 19.3894 10.1946 19.5205C10.0634 19.6517 9.88556 19.7254 9.70008 19.7254H9.70052Z" />
                                      <path d="M26.398 23.1975C25.573 23.1964 24.7821 22.8683 24.1987 22.285C23.6153 21.7017 23.2871 20.9108 23.2859 20.0858C23.2847 19.6109 23.3933 19.142 23.6032 18.716C23.6437 18.6335 23.7001 18.5598 23.769 18.4991C23.838 18.4384 23.9183 18.3918 24.0052 18.3622C24.0922 18.3325 24.1842 18.3202 24.2759 18.326C24.3676 18.3319 24.4572 18.3557 24.5397 18.3962C24.6222 18.4367 24.6959 18.4931 24.7566 18.5621C24.8173 18.631 24.8638 18.7113 24.8935 18.7983C24.9232 18.8852 24.9355 18.9772 24.9296 19.0689C24.9238 19.1606 24.8999 19.2502 24.8594 19.3327C24.7438 19.5669 24.684 19.8247 24.6846 20.0858C24.6918 20.5356 24.8755 20.9644 25.1961 21.28C25.5166 21.5955 25.9484 21.7723 26.3982 21.7723C26.848 21.7723 27.2798 21.5955 27.6004 21.28C27.9209 20.9644 28.1046 20.5356 28.1118 20.0858C28.1124 19.8247 28.0526 19.5669 27.937 19.3327C27.8956 19.2502 27.871 19.1603 27.8645 19.0682C27.858 18.9761 27.8698 18.8836 27.8993 18.7961C27.9287 18.7086 27.9752 18.6278 28.0361 18.5584C28.0969 18.4889 28.1709 18.4322 28.2537 18.3915C28.3366 18.3508 28.4267 18.3269 28.5188 18.3212C28.611 18.3155 28.7034 18.328 28.7906 18.3582C28.8779 18.3884 28.9583 18.4355 29.0272 18.4969C29.0962 18.5583 29.1523 18.6328 29.1923 18.716C29.4024 19.142 29.511 19.6108 29.5096 20.0858C29.5086 20.9108 29.1804 21.7016 28.5971 22.2849C28.0138 22.8683 27.2229 23.1964 26.398 23.1975Z" />
                                      <path d="M11.8694 23.1974C11.0443 23.1965 10.2533 22.8683 9.66987 22.2849C9.08644 21.7015 8.75826 20.9104 8.75734 20.0853C8.75595 19.6103 8.86457 19.1415 9.07467 18.7155C9.11469 18.6323 9.1708 18.5578 9.23974 18.4964C9.30869 18.435 9.38911 18.3879 9.47636 18.3577C9.56362 18.3276 9.65598 18.315 9.74813 18.3207C9.84028 18.3264 9.93038 18.3503 10.0132 18.391C10.0961 18.4317 10.1701 18.4884 10.2309 18.5579C10.2918 18.6273 10.3382 18.7081 10.3677 18.7956C10.3971 18.8831 10.409 18.9756 10.4025 19.0677C10.396 19.1598 10.3714 19.2497 10.33 19.3322C10.2144 19.5664 10.1546 19.8242 10.1552 20.0853C10.1552 20.5399 10.3357 20.9758 10.6571 21.2972C10.9785 21.6186 11.4145 21.7992 11.869 21.7992C12.3235 21.7992 12.7594 21.6186 13.0809 21.2972C13.4023 20.9758 13.5828 20.5399 13.5828 20.0853C13.5834 19.8242 13.5236 19.5664 13.408 19.3322C13.3666 19.2497 13.342 19.1598 13.3355 19.0677C13.329 18.9756 13.3408 18.8831 13.3703 18.7956C13.3997 18.7081 13.4462 18.6273 13.5071 18.5579C13.5679 18.4884 13.6419 18.4317 13.7247 18.391C13.8076 18.3503 13.8977 18.3264 13.9898 18.3207C14.082 18.315 14.1744 18.3276 14.2616 18.3577C14.3489 18.3879 14.4293 18.435 14.4982 18.4964C14.5672 18.5578 14.6233 18.6323 14.6633 18.7155C14.8739 19.1415 14.9831 19.6105 14.9824 20.0858C14.9812 20.9109 14.6529 21.7019 14.0693 22.2852C13.4857 22.8686 12.6946 23.1966 11.8694 23.1974Z" />
                                      <path d="M19.1326 31.9116C16.1762 31.9115 13.3113 30.8863 11.026 29.0107C8.74068 27.1351 7.17643 24.5251 6.59974 21.6255C6.02305 18.7259 6.4696 15.716 7.86331 13.1087C9.25702 10.5014 11.5117 8.45797 14.2431 7.32664C16.9745 6.19532 20.0136 6.04607 22.8427 6.90431C25.6718 7.76256 28.1159 9.5752 29.7583 12.0334C31.4008 14.4916 32.1401 17.4432 31.8503 20.3854C31.5605 23.3276 30.2595 26.0783 28.169 28.1688C26.9851 29.3592 25.5768 30.3029 24.0257 30.9454C22.4746 31.5878 20.8115 31.9162 19.1326 31.9116ZM19.1326 7.75183C12.8573 7.75183 7.75206 12.8571 7.75206 19.1324C7.75206 25.4077 12.8573 30.5129 19.1326 30.5129C25.4079 30.5129 30.5132 25.4077 30.5132 19.1324C30.5132 12.8571 25.4079 7.75183 19.1326 7.75183Z" />
                                      <path d="M19.1338 22.6168C18.4449 22.6168 17.7715 22.4125 17.1987 22.0297C16.6259 21.647 16.1794 21.103 15.9158 20.4665C15.6521 19.8301 15.5832 19.1297 15.7176 18.454C15.852 17.7784 16.1837 17.1577 16.6708 16.6706C17.158 16.1835 17.7786 15.8517 18.4543 15.7173C19.13 15.5829 19.8303 15.6519 20.4668 15.9155C21.1032 16.1792 21.6472 16.6256 22.03 17.1984C22.4127 17.7712 22.617 18.4447 22.617 19.1336C22.616 20.0571 22.2486 20.9424 21.5957 21.5954C20.9427 22.2484 20.0573 22.6157 19.1338 22.6168ZM19.1338 17.0491C18.7215 17.0491 18.3185 17.1713 17.9757 17.4004C17.6329 17.6294 17.3658 17.955 17.208 18.3359C17.0502 18.7168 17.009 19.1359 17.0894 19.5402C17.1698 19.9446 17.3683 20.316 17.6599 20.6075C17.9514 20.8991 18.3228 21.0976 18.7272 21.178C19.1315 21.2584 19.5506 21.2172 19.9315 21.0594C20.3124 20.9016 20.638 20.6344 20.867 20.2917C21.0961 19.9489 21.2183 19.5458 21.2183 19.1336C21.2177 18.5809 20.9979 18.051 20.6071 17.6603C20.2163 17.2695 19.6865 17.0497 19.1338 17.0491Z" />
                                    </g>
                                  </svg>
                                </div>
                                <div class="process-content">
                                  <h3>Install & Track</h3>
                                  <p>
                                    Real-time monitoring helps us reduce time
                                    wastage and offers ease in tracking the
                                    installation process.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="single-process">
                              <span class="dot"></span>
                              <div class="process-content-wrap four">
                                <div class="icon">
                                  <svg
                                    width="38"
                                    height="38"
                                    viewBox="0 0 38 38"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g>
                                      <path d="M19.0927 14.4476C23.3879 14.3109 23.3869 8.08335 19.0926 7.94727C14.7974 8.08399 14.7984 14.3115 19.0927 14.4476ZM19.0927 9.27748C19.5981 9.28313 20.081 9.4879 20.4365 9.84736C20.7919 10.2068 20.9913 10.6919 20.9913 11.1975C20.9913 11.703 20.7919 12.1881 20.4364 12.5476C20.081 12.907 19.5981 13.1118 19.0926 13.1174C18.5871 13.1118 18.1042 12.907 17.7488 12.5475C17.3933 12.1881 17.194 11.7029 17.194 11.1974C17.194 10.6919 17.3934 10.2068 17.7488 9.84732C18.1043 9.48787 18.5872 9.28311 19.0927 9.27748Z" />
                                      <path d="M15.6153 22.7012C15.5279 22.7011 15.4414 22.7183 15.3607 22.7517C15.28 22.7851 15.2067 22.8341 15.1449 22.8959C15.0831 22.9576 15.0341 23.031 15.0007 23.1117C14.9673 23.1924 14.9501 23.2789 14.9502 23.3663V28.8592C14.9508 29.0353 15.0211 29.2039 15.1457 29.3282C15.2704 29.4524 15.4393 29.5222 15.6153 29.5222C15.7913 29.5222 15.9602 29.4524 16.0849 29.3282C16.2095 29.2039 16.2798 29.0353 16.2804 28.8592V23.3663C16.2804 23.2789 16.2633 23.1924 16.2299 23.1117C16.1965 23.031 16.1475 22.9576 16.0857 22.8959C16.0239 22.8341 15.9506 22.7851 15.8699 22.7517C15.7892 22.7183 15.7027 22.7011 15.6153 22.7012Z" />
                                      <path d="M19.0919 25.4478C19.0045 25.4477 18.918 25.4649 18.8373 25.4983C18.7566 25.5317 18.6832 25.5807 18.6215 25.6424C18.5597 25.7042 18.5107 25.7776 18.4773 25.8583C18.4439 25.939 18.4267 26.0255 18.4268 26.1129V29.5053C18.4268 29.6817 18.4968 29.8508 18.6216 29.9756C18.7463 30.1003 18.9155 30.1704 19.0919 30.1704C19.2683 30.1704 19.4374 30.1003 19.5622 29.9756C19.6869 29.8508 19.757 29.6817 19.757 29.5053V26.1129C19.757 26.0255 19.7398 25.939 19.7064 25.8583C19.673 25.7776 19.624 25.7042 19.5623 25.6424C19.5005 25.5807 19.4272 25.5317 19.3464 25.4983C19.2657 25.4649 19.1792 25.4477 19.0919 25.4478Z" />
                                      <path d="M22.5694 22.7012C22.482 22.7011 22.3955 22.7183 22.3148 22.7517C22.2341 22.7851 22.1608 22.8341 22.099 22.8959C22.0372 22.9576 21.9882 23.031 21.9548 23.1117C21.9214 23.1924 21.9042 23.2789 21.9043 23.3663V28.8592C21.9049 29.0353 21.9752 29.2039 22.0998 29.3282C22.2245 29.4524 22.3934 29.5222 22.5694 29.5222C22.7454 29.5222 22.9143 29.4524 23.039 29.3282C23.1636 29.2039 23.2339 29.0353 23.2345 28.8592V23.3663C23.2345 23.2789 23.2174 23.1924 23.184 23.1117C23.1506 23.031 23.1016 22.9576 23.0398 22.8959C22.978 22.8341 22.9047 22.7851 22.824 22.7517C22.7433 22.7183 22.6568 22.7011 22.5694 22.7012Z" />
                                      <path d="M35.5189 31.7094H34.0179V14.7103C34.0173 14.0968 33.7734 13.5086 33.3396 13.0748C32.9059 12.6409 32.3178 12.3968 31.7043 12.3961H26.1957L25.9376 12.244C25.8904 10.0606 25.4053 7.90902 24.511 5.9167C23.6167 3.92438 22.3314 2.13195 20.7314 0.645701C20.2864 0.230601 19.7005 -0.000244141 19.092 -0.000244141C18.4835 -0.000244141 17.8976 0.230601 17.4526 0.645701C15.8526 2.13195 14.5673 3.92438 13.673 5.9167C12.7787 7.90902 12.2936 10.0606 12.2465 12.244L11.9883 12.3961H6.60769C5.9941 12.3967 5.40583 12.6407 4.97196 13.0746C4.53809 13.5084 4.29408 14.0967 4.29346 14.7103V31.7094H2.66511C2.57775 31.7093 2.49124 31.7265 2.41052 31.7599C2.32981 31.7933 2.25646 31.8423 2.19469 31.9041C2.13292 31.9659 2.08393 32.0392 2.05053 32.1199C2.01712 32.2006 1.99995 32.2871 2 32.3745V33.7463C2.0011 34.6751 2.37058 35.5656 3.02737 36.2224C3.68417 36.8792 4.57466 37.2487 5.50351 37.2498H32.6805C33.6094 37.2487 34.4998 36.8792 35.1566 36.2224C35.8134 35.5656 36.1829 34.6751 36.184 33.7463V32.3745C36.1841 32.2871 36.1669 32.2006 36.1335 32.1199C36.1001 32.0392 36.0511 31.9659 35.9893 31.9041C35.9275 31.8423 35.8542 31.7933 35.7735 31.7599C35.6928 31.7265 35.6062 31.7093 35.5189 31.7094ZM16.2718 33.0396H22.0408V33.8145H16.2718V33.0396ZM25.9053 13.7687L28.1384 15.0844C28.2901 15.1748 28.4088 15.3115 28.4771 15.4743C28.5454 15.6372 28.5596 15.8176 28.5178 15.9892L27.109 21.6244C27.0706 21.7849 26.9846 21.9299 26.8621 22.0405C26.7397 22.1511 26.5866 22.222 26.4231 22.2438C26.2595 22.2656 26.0932 22.2373 25.9461 22.1627C25.7989 22.0881 25.6779 21.9706 25.5988 21.8258L24.3732 19.6374C25.2493 17.7952 25.7691 15.804 25.9053 13.7687ZM18.3542 1.62387C18.5546 1.43728 18.8182 1.33354 19.092 1.33354C19.3658 1.33354 19.6295 1.43728 19.8299 1.62387C22.1539 3.79302 23.7325 6.64157 24.3399 9.7621C24.9472 12.8826 24.5522 16.1153 23.2112 18.9977H21.0154L21.3205 17.2135C21.3435 17.0739 21.336 16.931 21.2985 16.7945C21.2609 16.6581 21.1943 16.5314 21.1031 16.4232C21.012 16.315 20.8984 16.2278 20.7703 16.1677C20.6422 16.1076 20.5026 16.0759 20.3611 16.0749H17.8358C17.6916 16.076 17.5494 16.1089 17.4194 16.1712C17.2894 16.2336 17.1747 16.3239 17.0836 16.4357C16.9925 16.5475 16.9273 16.6781 16.8925 16.8181C16.8577 16.958 16.8542 17.1039 16.8824 17.2454L17.2433 18.9978H14.9728C13.6319 16.1153 13.2368 12.8826 13.8441 9.7621C14.4515 6.64157 16.0301 3.79302 18.3542 1.62387ZM18.2736 17.4051H19.9383L19.1829 21.8218L18.2736 17.4051ZM10.0456 15.0844L12.2787 13.7687C12.4149 15.804 12.9347 17.7952 13.8108 19.6373L12.5852 21.8257C12.5062 21.9706 12.3851 22.0881 12.238 22.1628C12.0908 22.2374 11.9245 22.2657 11.761 22.2439C11.5974 22.2221 11.4443 22.1512 11.3218 22.0406C11.1994 21.93 11.1133 21.7849 11.0751 21.6244L9.6669 15.9892C9.62475 15.8177 9.63881 15.6372 9.70698 15.4743C9.77516 15.3114 9.89385 15.1748 10.0456 15.0844ZM5.62369 14.7103C5.62406 14.4494 5.72786 14.1994 5.91231 14.0149C6.09677 13.8305 6.34684 13.7267 6.6077 13.7263H9.73055C9.23579 13.9277 8.82834 14.2978 8.58046 14.7711C8.33257 15.2443 8.26026 15.7899 8.37636 16.3114L9.78511 21.9465C9.89472 22.3601 10.1246 22.7318 10.4456 23.0146C10.7666 23.2974 11.1643 23.4786 11.5884 23.5352C12.0124 23.5918 12.4438 23.5213 12.8277 23.3326C13.2117 23.1439 13.531 22.8455 13.7452 22.4751L14.9478 20.328H17.5173L18.145 23.3755C18.1957 23.6228 18.3313 23.8446 18.5282 24.0025C18.7251 24.1605 18.9711 24.2447 19.2235 24.2405C19.4759 24.2363 19.7189 24.1441 19.9105 23.9797C20.1021 23.8154 20.2303 23.5892 20.2728 23.3404L20.7879 20.328H23.2362L24.4388 22.4752C24.6531 22.8455 24.9724 23.1439 25.3564 23.3326C25.7403 23.5213 26.1717 23.5918 26.5957 23.5352C27.0198 23.4785 27.4175 23.2973 27.7385 23.0145C28.0595 22.7317 28.2893 22.36 28.3989 21.9464L29.8084 16.3113C29.9184 15.8615 29.8811 15.3882 29.7021 14.9611C29.5231 14.534 29.2118 14.1756 28.8139 13.9386L28.4535 13.7263H31.7043C31.9651 13.7267 32.2151 13.8305 32.3994 14.0149C32.5838 14.1994 32.6874 14.4495 32.6876 14.7103V31.7068H5.62367L5.62369 14.7103ZM34.8538 33.7463C34.8531 34.3225 34.624 34.8749 34.2165 35.2823C33.8091 35.6897 33.2567 35.9189 32.6805 35.9195H5.50351C4.92732 35.9189 4.37491 35.6897 3.96749 35.2823C3.56006 34.8749 3.33088 34.3225 3.33023 33.7463V33.0396H14.9416V34.4796C14.9415 34.5669 14.9587 34.6534 14.9921 34.7342C15.0255 34.8149 15.0745 34.8882 15.1363 34.95C15.1981 35.0118 15.2714 35.0607 15.3521 35.0942C15.4328 35.1276 15.5193 35.1447 15.6067 35.1447H22.7059C22.7933 35.1447 22.8798 35.1276 22.9605 35.0942C23.0412 35.0607 23.1146 35.0118 23.1763 34.95C23.2381 34.8882 23.2871 34.8149 23.3205 34.7342C23.3539 34.6534 23.3711 34.5669 23.371 34.4796V33.0396H34.8538L34.8538 33.7463Z" />
                                    </g>
                                  </svg>
                                </div>
                                <div class="process-content">
                                  <h3>Audit & Comply</h3>
                                  <p>
                                    Our CRM automatically generates CES and VBA
                                    documents and ensures the auditing as well.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="home4-about-us-section mb-120 ">
              <div class="container">
                <div class="row gy-5">
                  <div class="col-lg-6 order-lg-1 order-2">
                    <div class="about-us-left-area">
                      <div class="img-area">
                        <div class="left-icon">
                          <svg
                            class="rotating-icon"
                            width="98"
                            height="99"
                            viewBox="0 0 98 99"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g>
                              <path d="M48.9999 0H55.3925L52.1962 24.5284L48.9999 49.0607L45.8037 24.5284L42.6074 0H48.9999Z" />
                              <path d="M48.9999 98.0419H42.6074L45.8037 73.5096L48.9999 48.9772L52.1962 73.5096L55.3925 98.0419H48.9999Z" />
                              <path d="M98.0002 49.021V55.4162L73.4781 52.2186L48.9561 49.021L73.4781 45.8234L98.0002 42.6218V49.021Z" />
                              <path d="M0 49.021V42.6217L24.5221 45.8233L49.0401 49.021L24.5221 52.2186L0 55.4162V49.021Z" />
                              <path d="M83.6503 14.3558L88.1688 18.8801L68.5702 33.9666L48.9717 49.049L64.0478 29.4422L79.1279 9.83142L83.6503 14.3558Z" />
                              <path d="M14.3485 83.6825L9.83008 79.1621L29.4287 64.0757L49.0272 48.9893L33.9511 68.6L18.871 88.2069L14.3485 83.6825Z" />
                              <path d="M83.6503 83.6825L79.1279 88.2069L64.0478 68.6L48.9717 48.9893L68.5702 64.0757L88.1688 79.1621L83.6503 83.6825Z" />
                              <path d="M14.3485 14.3558L18.871 9.83142L33.9511 29.4422L49.0272 49.049L29.4287 33.9666L9.83008 18.8801L14.3485 14.3558Z" />
                            </g>
                          </svg>
                        </div>
                        <div class="right-img">
                          <img src="assets/new-2.png" alt="" />
                        </div>
                      </div>
                      <div class="feature-wrap">
                        <div class="title-area">
                          <h3>Before:</h3>
                        </div>
                        <div class="throwable-box-wrap">
                          <div
                            class="throwable-item-wrap"
                            data-eg-throwable-scene="true"
                          >
                            <p data-eg-throwable-el>
                              <span class="throwable-item">Google Sheets</span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="terracotta throwable-item">
                                Emails
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="periwinkle throwable-item">
                                WhatsApp
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="muted-green throwable-item">
                                Missed Reminders
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="aqua-green throwable-item">
                                Phone Notes
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="red throwable-item">
                                Paper Documents
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="green throwable-item">
                                Spreadsheets
                              </span>
                            </p>
                            <p data-eg-throwable-el>
                              <span class="green throwable-item">
                                Manual Follow-ups
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 order-lg-2 order-1">
                    <div class="about-us-right-area">
                      <div class="section-title">
                        <span>Goodbye to manual work</span>
                        <h2 class="text-anim">After</h2>

                        <div class="">
                          <img
                            src="assets/new.png"
                            alt=""
                            style={{ borderRadius: "10px" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
         <div className="as">
  <div className="as-ring1"></div>
  <div className="as-ring2"></div>
  <div className="as-dot1"></div>
  <div className="as-dot2"></div>

  <span className="as-badge">Easy-to-Use Solutions</span>
  <h2 className="ecrm-title">
    Integrating built-in <em>automation</em>
    <br />
    for renewable sector
  </h2>
  <p className="as-sub">
    We offer you highly encrypted CRM software to manage all
    energy-efficient requirements from one single place.
  </p>

  <div className="as-grid">
    <div className="as-card">
      <div className="as-card-title">Lighting</div>
      <div className="as-card-desc">
        VEU and ESS assistance for lighting rebates and incentives.
      </div>
      <div className="as-shape-wrap">
        <div className="swirl-1">
          <div className="swirl-inner"></div>
        </div>

        <div className="as-chip" style={{ top: "10px", left: "0px" }}>
          <svg width="12" height="12" fill="none" stroke="#d4a017" strokeWidth="2" viewBox="0 0 24 24">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <path d="M8 21h8M12 17v4" />
          </svg>
          Thorough Assistance
        </div>

        <div className="as-chip" style={{ bottom: "30px", left: "0px" }}>
          <svg width="12" height="12" fill="none" stroke="#3B6D11" strokeWidth="2" viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </svg>
          Custom Packages
        </div>

        <div className="as-chip" style={{ bottom: "5px", right: "-10px" }}>
          <svg width="12" height="12" fill="none" stroke="#185FA5" strokeWidth="2" viewBox="0 0 24 24">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
          </svg>
          Increase Efficiency
        </div>
      </div>
    </div>

    <div className="as-card">
      <div className="as-card-title">HVAC & Air Conditioning</div>
      <div className="as-card-desc">
        Thorough assessment of your needs and accurate solutions for
        the same.
      </div>
      <div className="as-shape-wrap">
        <div className="swirl-2">
          <div className="swirl-inner"></div>
        </div>

        <div className="as-chip" style={{ top: "8px", right: "-5px" }}>
          <svg width="12" height="12" fill="none" stroke="#185FA5" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M9 11l3 3L22 4" />
          </svg>
          Assessment
        </div>

        <div className="as-chip" style={{ bottom: "40px", left: "-10px" }}>
          <svg width="12" height="12" fill="none" stroke="#d4a017" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="3" />
            <path d="M12 1v4M12 19v4" />
          </svg>
          Right Solutions
        </div>

        <div className="as-chip" style={{ bottom: "8px", right: "-5px" }}>
          <svg width="12" height="12" fill="none" stroke="#3B6D11" strokeWidth="2" viewBox="0 0 24 24">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
          </svg>
          Real-Time Updates
        </div>
      </div>
    </div>

    <div className="as-card">
      <div className="as-card-title">Solar Installation</div>
      <div className="as-card-desc">
        Offer you the right guidance as per your energy
        requirements.
      </div>
      <div className="as-shape-wrap">
        <div className="swirl-3">
          <div className="swirl-inner"></div>
        </div>

        <div className="as-chip" style={{ top: "5px", left: "-5px" }}>
          <svg width="12" height="12" fill="none" stroke="#d4a017" strokeWidth="2" viewBox="0 0 24 24">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
          </svg>
          Tailored Solutions
        </div>

        <div className="as-chip" style={{ bottom: "38px", right: "-10px" }}>
          <svg width="12" height="12" fill="none" stroke="#185FA5" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4l3 3" />
          </svg>
          Right Guidance
        </div>

        <div className="as-chip" style={{ bottom: "8px", left: "-5px" }}>
          <svg width="12" height="12" fill="none" stroke="#3B6D11" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          </svg>
          Energy Management
        </div>
      </div>
    </div>

    <div className="as-card">
      <div className="as-card-title">Hot Water System</div>
      <div className="as-card-desc">
        Ease in managing your hot water systems without much stress.
      </div>
      <div className="as-shape-wrap">
        <div className="swirl-4">
          <div className="swirl-inner"></div>
        </div>

        <div className="as-chip" style={{ top: "8px", left: "-5px" }}>
          <svg width="12" height="12" fill="none" stroke="#185FA5" strokeWidth="2" viewBox="0 0 24 24">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <path d="M8 21h8" />
          </svg>
          Seamless Management
        </div>

        <div className="as-chip" style={{ bottom: "40px", left: "-10px" }}>
          <svg width="12" height="12" fill="none" stroke="#d4a017" strokeWidth="2" viewBox="0 0 24 24">
            <polyline points="23 4 23 10 17 10" />
            <path d="M20.49 15a9 9 0 1 1-.18-4.55" />
          </svg>
          Timely Updates
        </div>

        <div className="as-chip" style={{ bottom: "8px", right: "-5px" }}>
          <svg width="12" height="12" fill="none" stroke="#3B6D11" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          </svg>
          Installation
        </div>
      </div>
    </div>
  </div>
</div>
          </div>
        </div>
      </div>
    </>
  );
}
